export interface FilterValues {
    datumVon: string;
    datumBis: string;
    artikelGruppeNr: number;
    artikelNr: string;
    showCompare?: boolean;
}

export interface LineData {
    kNr: number;
    kName: string;
    artikelGruppeNr: number;
    artikelNr: string;
    artikelText: string;
    reclayProduktgruppe: string;
    einheit: string;
    menge: number;
    aufwand: number;
    umsatz: number;
    // bMarge: number;
    // bMargeP: number;
}

export const defaultLineData: LineData = {
    kNr: 0,
    kName: '',
    artikelGruppeNr: 0,
    artikelNr: '',
    artikelText: '',
    reclayProduktgruppe: '',
    einheit: '',
    menge: 0,
    aufwand: 0,
    umsatz: 0,
    // bMarge: 0,
    // bMargeP: 0,
};

export interface ArtikelumsatzSummary {
    loading: boolean;
    lines: LineData[];
    totalMenge: number;
    totalAufwand: number;
    totalUmsatz: number;
}
